import { Metric } from "./Finance.model";
import { createApiClient, createMutation } from "@/api/utils";

export const getMetricsV2 = createMutation<Metric[], { metricQuery: string }>(
    async ({ router, payload, session, queryClient }) => {
        const response = await createApiClient({
            token: session.token.data || undefined,
            convert: false,
        }).get(
            `https://finance.humcapital.info/api/beta/companies/${router.params.companyId}/metric-query?value_kind=lineage&m=${payload.metricQuery}`,
        );

        queryClient.setQueryData([payload.metricQuery], () => response);

        console.log("Response received:", response);

        return response;
    },
);
